export const initialState = {
  items: [],
  keyword: "",
};
